import { oneLineTrim } from 'common-tags'

import { environment } from "../config/environment"

const {
    activeDirectoryB2CAuthorizeUrl: B2C_AUTHORIZE_URL,
    activeDirectoryB2CPasswordResetUrl: B2C_PASSWORD_RESET_URL,
    activeDirectoryRedirectUri: DIRECTORY_REDIRECT_URI,
} = environment

export const composeActiveDirectoryUrl = (
    activeDirectoryClientId,
) => oneLineTrim`${B2C_AUTHORIZE_URL}
        &client_id=${activeDirectoryClientId}
        &scope=${encodeURIComponent(
            `${activeDirectoryClientId} offline_access`,
        )}
        &redirect_uri=${encodeURIComponent(DIRECTORY_REDIRECT_URI)}
        &response_type=code
        &response_mode=query
        &prompt=login
        &nonce=defaultNonce
    `

export const composeResetPasswordUrl = (
    activeDirectoryClientId,
) => oneLineTrim`${B2C_PASSWORD_RESET_URL}
        &client_id=${activeDirectoryClientId}
        &scope=${encodeURIComponent(
            `${activeDirectoryClientId} offline_access`,
        )}
        &redirect_uri=${encodeURIComponent(DIRECTORY_REDIRECT_URI)}
        &response_type=code
        &state=pw_reset
    `

export const loginWithActiveDirectory = (activeDirectoryClientId) => {
    const href = composeActiveDirectoryUrl(activeDirectoryClientId)
    window.location.href = href
}

export const resetActiveDirectoryPassword = (activeDirectoryClientId) => {
    const href = composeResetPasswordUrl(activeDirectoryClientId)
    window.location.href = href
}
